module.exports = __webpack_public_path__ + "static/media/text-message.770fb7aa.jpeg";